import {
  Component,
  ViewEncapsulation,
  OnInit, Inject, OnDestroy, ViewChild, AfterViewInit
} from '@angular/core';
import {
  State
} from '@progress/kendo-data-query';
import {
  DataStateChangeEvent,
  GridDataResult, RowArgs, SelectionEvent,
} from '@progress/kendo-angular-grid';
import {
  Observable
, Subscription} from 'rxjs';
import {
  FormControl
} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {UserContext} from '../../../../services/user-context/user-context';
import {ConfirmDialogComponent} from '../../../../shared/layout/components/confirm-dialog/confirm-dialog.component';
import {UserDialogComponent} from './user-dialog.component';
import {UsersService} from './users.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {ApiService} from '../../../../services/api/api.service';
import {DOCUMENT} from '@angular/common';
import {GoogleMapsAPIWrapper, AgmMap, LatLngBounds, LatLngBoundsLiteral} from '@agm/core';
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {HttpParams} from "@angular/common/http";
import {SearchContext} from '../../../../services/search/search-context';

declare var google: any;

@Component({
  selector: 'app-users',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'users.template.html'
})
export class UsersComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(AgmMap, {static: true})
  public agmMap: AgmMap;

  public view: Observable<GridDataResult>;
  public subscription: Subscription;
  public state: State = {
    skip: 0,
    take: 10
  };
  private searchTerm: string;
  private selectedUser: RowArgs;
  lat = 35.268107;
  lng = -90.744821;
  zoom = 4;

  loading = false;
  public crumbs: any[] = [
    {label: 'Accounts', link: '/accounts'}
  ];
  private markers: any[] = [];
  private locations: any[] = [];
  private map: any;

  public search: Subscription;

  public mapStyles = [
    {elementType: 'geometry', stylers: [{color: '#aec3cb'}]},
    {elementType: 'labels.text.stroke', stylers: [{'visibility': 'off'}]},
    {elementType: 'labels.text.fill', stylers: [{color: '#888888'}]},
    {
      featureType: 'administrative.locality',
      elementType: 'labels.text.fill',
      stylers: [{color: '#555555'}]
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [{'visibility': 'off'}]
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{color: '#c0d7e0'}]
    },
    {
      featureType: 'road',
      elementType: 'geometry.stroke',
      stylers: [{color: '#bbdefb'}]
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [{color: '#9ca5b3'}]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [{color: '#c0d7e0'}]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [{color: '#c0d7e0'}]
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.text.fill',
      stylers: [{color: '#81d4fa'}]
    },
    {
      featureType: 'transit',
      elementType: 'geometry',
      stylers: [{color: '#2f3948'}]
    },
    {
      featureType: 'transit.station',
      elementType: 'labels.text.fill',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{color: '#e3e8ee'}]
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'water',
      elementType: 'labels.text.stroke',
      stylers: [{color: 'transparent'}]
    }
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private searchContext: SearchContext,
    private usersService: UsersService,
    private api: ApiService,
    private snackBar: MatSnackBar,
    private userContext: UserContext,
    @Inject(DOCUMENT) private document: Document) {

    this.view = usersService;
  }

  public ngOnInit(): void {

    this.view.subscribe((users) => {
      this.api.get<any>(`/account/${(this.userContext.account || {}).id}/location`)
        .subscribe(locations => {
          if (locations) {
            this.locations = locations;

            if (users) {
              const userLocations: any[] = [];
              users.data.map( (user) => {
                if ( user.locations && user.locations.length ) {
                  const filteredLocations = locations.filter((location) => user.locations.includes(location.id));
                  if ( filteredLocations.length ) {
                    const userLocation = filteredLocations[0];
                    if ( userLocation.latlng ) {
                      userLocations.push({latitude: userLocation.latlng[0], longitude: userLocation.latlng[1]});
                    }
                  }
                }
              });
              this.markers = userLocations;
              this.centerMap();
            }
          }
        });
    });


  }

  public ngAfterViewInit(): void {
    this.agmMap.mapReady.subscribe(map => {
      this.map = map;
      this.search = this.searchContext.searchObserver.pipe(debounceTime(400), distinctUntilChanged()).subscribe((term) => {
        if ((term || "").length >= 3 || (term || "").length === 0) {
          this.state.skip = 0;
          this.getUsers(term);
        }
      });
    });
  }

  public ngOnDestroy(): void {
    this.search.unsubscribe();
  }

  public onUserSelection(event: SelectionEvent) {
    this.selectedUser = event.selectedRows[0];
  }

  public dataUserStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.getUsers(this.searchTerm || '');
  }

  public getLocationDescription( userLocations: any[]): string {
    return this.locations.filter((location) => userLocations.includes(location.id)).map((location) => location.name).toString();
  }

  public getUsers(search: string) {
    const page = this.state.skip / this.state.take + 1;
    const limit = this.state.take;

    this.usersService.getUsers(page, limit, () => {
      this.loading = false;
    }, (this.userContext.account || {}).id || this.route.snapshot.paramMap.get('id'), search);
  }

  public centerMap(): void {
    const bounds: LatLngBounds = new google.maps.LatLngBounds();
    for (const mm of this.markers) {
      bounds.extend(new google.maps.LatLng(mm.latitude, mm.longitude));
    }
    this.map.fitBounds(bounds);
    if ( this.map.getZoom() > 7 ) {
      this.map.setZoom(7);
    }
  }

  public onMapReady($event) {
    this.agmMap.triggerResize(true);
  }

  public addUser(): void {
    const dialogRef = this.dialog.open(UserDialogComponent, {
      width: '600px',
      data: {locations: this.locations || []}
    });

    dialogRef.afterClosed().subscribe(user => {

      if ( user ) {
        delete user.confirm;
        if( user.titles ) {
          user.titles = user.titles.trim().split(/[, ]/);
        }

        this.api.post<any>(`/account/${this.userContext.account.id}/user`, user ).subscribe( result => {
          this.snackBar.open('User added.', null, {
            duration: 2000
          });
          this.getUsers(this.searchTerm || '');
        }, (error) => {
          this.snackBar.open(`Error adding user: ${error}`, null, {
            duration: 2000
          });
        });
      }
    });
  }

  public editUser(): void {
    const dialogRef = this.dialog.open(UserDialogComponent, {
      width: '600px',
      data: {locations: this.locations || [], user: this.selectedUser.dataItem}
    });

    dialogRef.afterClosed().subscribe(user => {

      if ( user ) {
        user._id = this.selectedUser.dataItem._id;

        delete user.confirm;
        if ( user._id && !user.password ) {
          delete user.password;
        }

        if ( !user.external_id ) {
          delete user.external_id;
        }
        if( user.titles ) {
          user.titles = user.titles.trim().split(/[, ]/);
        }

        this.api.patch<any>(`/user/${user._id}`, user).subscribe( result => {
          this.snackBar.open('User updated.', null, {
            duration: 2000
          });
          this.getUsers(this.searchTerm || '');
        }, (error) => {
          this.snackBar.open(`Error updating user: ${error}`, null, {
            duration: 2000
          });
        });
      }

      this.selectedUser = null;
    });
  }

  public removeUser(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '300px',
      data: { message: 'Remove this user?', action: 'Remove'}
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if ( confirmed ) {
        this.api.del<any>(`/user/${this.selectedUser.dataItem._id}` ).subscribe( result => {
          this.snackBar.open('User removed.', null, {
            duration: 2000
          });
          this.getUsers(this.searchTerm || '');
        }, (error) => {
          this.snackBar.open(`Error removing user: ${error}`, null, {
            duration: 2000
          });
        });
      }
      this.selectedUser = null;
    });
  }

}
